export default __webpack_public_path__ + "static/media/recovery.2a9a944d.svg";